import React from "react";
import "./FlightResultsLayout.css";

/** Workspace grid: sidebar 248px (inline-start in RTL = right) + results flex. */
export default function FlightResultsLayout({ sidebar, children }) {
  return (
    <div className="fe2-rws">
      <div className="fe2-rws__sidebar">{sidebar}</div>
      <div className="fe2-rws__main">{children}</div>
    </div>
  );
}
